import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import NavbarMenu from './component/NavbarMenu';
import BottomFooter from './component/BottomFooter';
import AboutUs from './component/AboutUs';
import PrivacyPolicy from './component/PrivacyPolicy';
import TermsAndConditions from './component/TermsAndConditions';
import EmiCalculator from './component/tools/LoanClaculator/comps/EmiCalculator';
import PincodeAccess from './component/tools/Pincode/PincodeAccess';
import ToolsMenu from './component/ToolsMenu';


function App() {
  return (
  
    <Router>
      <div>
        <div>
          <NavbarMenu/>
        </div>
        <Routes>
        <Route path='/' element={<ToolsMenu/> } />
          <Route path='*' element={<div><h1 className="container d-flex justify-content-center text-center" > Page Not Exist </h1></div> } />
          <Route path='/emi-calculator' element={<EmiCalculator/> } />
          <Route path='/search-pincode' element={<PincodeAccess/> } />
          <Route path='/about' element={<AboutUs/> } />
          <Route path='/privacypolicy' element={<PrivacyPolicy/> } />
          <Route path='/termsandconditions' element={<TermsAndConditions/> } />
        </Routes>
        <BottomFooter/>
      </div>
    </Router>
  );
}

export default App;
                               